import React from 'react';
import { SunIcon, MoonIcon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
const ThemeToggle: React.FC = () => {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors focus:outline-none ${theme === 'dark' ? 'bg-teal-600' : 'bg-gray-300'}`} data-id="element-311">
      <span className={`inline-block h-5 w-5 transform rounded-full transition-transform ${theme === 'dark' ? 'translate-x-6 bg-gray-900' : 'translate-x-1 bg-white'}`} data-id="element-312">
        {theme === 'dark' ? <MoonIcon size={14} className="h-full w-full p-0.5 text-teal-400" data-id="element-313" /> : <SunIcon size={14} className="h-full w-full p-0.5 text-yellow-500" data-id="element-314" />}
      </span>
    </button>;
};
export default ThemeToggle;